module.exports = __webpack_public_path__ + "static/media/weibo.990e4da1.jpeg";